import { render } from "./ModalPage.vue?vue&type=template&id=edff0800&scoped=true"
import script from "./ModalPage.vue?vue&type=script&lang=js"
export * from "./ModalPage.vue?vue&type=script&lang=js"

import "./ModalPage.vue?vue&type=style&index=0&id=edff0800&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edff0800"]])

export default __exports__